import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { DEFAUTL_ACTIVTY_FILTERS_POPUP } from '@/utils/constants';
import { isEmptyValue } from '@/utils/utils';

@Component({
    name: 'popup-filter-layout',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
    },
})

export default class PopupFilterLayout extends Vue {

    @Prop()
    private filterList?: any;

    @Prop({ default: 'roster-popup' })
    private activeComponent?: string;

    @Prop({ default: null })
    private eventBind: any;

    @Prop({ default: null })
    private propBind: any;

    @Prop({ default: 'Details' })
    private cardName: any;

    private selectedDomainItem: any = {};

    private isDomainActive: boolean = false;

    private selectedCompetancyCode: any = [];

    private get competencyList() {
        return this.$store.state.activityStore.standardCompetencyList;
    }

    private onClose() {
        this.selectedCompetancyCode = [];
        this.$emit('onClose');
    }

    private get domainList() {
        return this.$store.state.activityStore.domainList;
    }

    private created() {
        this.preSelected(this.competencyList);
    }

    private onSelectDomain(item: any) {
        this.$store.state.activityStore.standardCompetencyList = [];
        this.selectedCompetancyCode = [];
        this.domainList.forEach((element: any) => {
            element.checked = false;
        });
        const domainDetails = {
            frameworkId: this.filterList.framework.standard_framework_id,
            subjectId: `${this.filterList.framework.standard_framework_id}.${this.filterList.subject.id}`,
            courseId: `${this.filterList.framework.standard_framework_id}.${this.filterList.course.id}`,
            domainId: item.id,
        };
        this.selectedDomainItem = item;
        this.$store.dispatch('activityStore/fetchCodes', domainDetails);
        this.isDomainActive = item.checked ? false : true;
        this.$set(item, 'checked', this.isDomainActive);
    }

    private onSelectCompetancy(selected: any) {
        const indexIntem = this.selectedCompetancyCode.findIndex((item: any) => {
            return item.id === selected.id;
        });
        if (indexIntem !== -1) {
            this.selectedCompetancyCode.splice(indexIntem, 1);
        } else {
            this.selectedCompetancyCode.push(selected);
        }
    }

    private onSelectFliter() {
        const domainFilter: any = DEFAUTL_ACTIVTY_FILTERS_POPUP[0];
        domainFilter.isActive = this.isDomainActive;
        this.$emit('onSelectCategory', this.isDomainActive ? this.selectedDomainItem : {}, domainFilter);


        const filter: any = DEFAUTL_ACTIVTY_FILTERS_POPUP[1];
        filter.isActive = false;
        const standardArray: any = [];
        if (this.selectedCompetancyCode && this.selectedCompetancyCode.length > 0) {
            this.selectedCompetancyCode.forEach((element: any) => {
                standardArray.push(element.id);
            });
            filter.isActive = true;
            this.$emit('onSelectCategory', (standardArray && standardArray.length > 0) ? standardArray : [], filter);
        }
        this.$emit('onClose');
    }

    private removeSelected(selected: any) {
        for (const iterator of this.competencyList) {
            if (isEmptyValue(selected.parent_taxonomy_code_id)) {
                if (iterator.id === selected.id) {
                    iterator.checked = false;
                }
            } else {
                if (iterator && iterator.children && iterator.children.length > 0) {
                    for (const iteratorChild of iterator.children) {
                        if (iteratorChild.id === selected.id) {
                            iteratorChild.checked = false;
                        }
                    }
                }
            }
        }

        const indexIntem = this.selectedCompetancyCode.findIndex((item: any) => {
            return item.id === selected.id;
        });

        if (indexIntem !== -1) {
            this.selectedCompetancyCode.splice(indexIntem, 1);
        }
    }

    private preSelected(list: any) {
        for (const iterator of list) {
            if (iterator.checked) {
                let parentIndex = -1;
                if (this.selectedCompetancyCode && this.selectedCompetancyCode.length > 0) {
                    parentIndex = this.selectedCompetancyCode.findIndex((item: any) => {
                        return item.id === iterator.id;
                    });
                }
                if (parentIndex === -1) {
                    this.selectedCompetancyCode.push(iterator);
                }
            }
            if (iterator.children && iterator.children.length > 0) {
                for (const iteratorChild of iterator.children) {
                    if (iteratorChild.checked) {
                        let childIndex = -1;
                        if (this.selectedCompetancyCode && this.selectedCompetancyCode.length > 0) {
                            childIndex = this.selectedCompetancyCode.findIndex((itemChild: any) => {
                                return itemChild.id === iteratorChild.id;
                            });
                        }
                        if (childIndex === -1) {
                            this.selectedCompetancyCode.push(iteratorChild);
                        }
                    }
                }
            }
        }
    }
}
